import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ColorModeScript} from "@chakra-ui/react"
import {themeGetter} from "./Theme";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <>
        <ColorModeScript initialColorMode={themeGetter().config.initialColorMode}/>
        <App/>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
